import React, { useRef, useState } from "react"
import { useSnackbar } from "notistack"
import {
  Avatar,
  Box,
  ButtonBase,
  Hidden,
  Menu,
  MenuItem,
  Typography,
  makeStyles,
} from "@material-ui/core"
import { Link } from "react-router-dom"
import { AccountCircle, Edit, ExitToApp, Settings } from "@material-ui/icons"
import { useDispatch, useSelector } from "react-redux"
import { selectRol, selectUser, signOut } from "src/redux/slices/authSlice"
import { removeComplex } from "src/redux/slices/complexSlice"
import { resetTheme } from "src/redux/slices/themeSlice"
import { Roles } from "src/utils/Constants"
import RolesSelector from "./RolesSelector"
import LanguageSelector from "./LanguageSelector"
import { useAccountMenuStyles } from "./accountMenuStyles"

const useStyles = makeStyles(theme => ({
  avatar: {
    height: 32,
    width: 32,
    marginRight: theme.spacing(1),
  },
  popover: {
    minWidth: 240,
    paddingTop: 0,
    paddingBottom: 0,
  },
}))

const Account = () => {
  const classes = useStyles()
  const menuClasses = useAccountMenuStyles()
  const dispatch = useDispatch()
  const rol = useSelector(selectRol)
  const user = useSelector(selectUser)
  const getProfilePath = () => {
    if (rol === Roles.admin) return "/administrador/perfil"
    if (rol === Roles.supervisor) return "/guardia/perfil"
    return "/perfil"
  }
  const profilePath = getProfilePath()

  const { enqueueSnackbar } = useSnackbar()

  const ref = useRef(null)
  const [isOpen, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleLogout = async () => {
    try {
      await dispatch(signOut()).unwrap()
      dispatch(removeComplex())
      sessionStorage.removeItem("inventario_auth")
      dispatch(resetTheme())
    } catch (err) {
      enqueueSnackbar("Error al cerrar su sesion", {
        variant: "error",
      })
    }
  }

  const renderMenuItem = (icon, label, props = {}) => (
    <MenuItem divider={false} className={menuClasses.menuItemLevel1} {...props}>
      <Box display="flex" alignItems="center" width="100%">
        {React.cloneElement(icon, { className: menuClasses.menuItemIcon })}
        <Typography className={menuClasses.menuItemLabel}>{label}</Typography>
      </Box>
    </MenuItem>
  )

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        className="mx-2"
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
      >
        <Avatar alt="User" className={classes.avatar} src={user.avatar} />
        <Hidden smDown>
          <Typography variant="h6" style={{ color: "initial" }}>
            {user.name}
          </Typography>
        </Hidden>
      </Box>
      <Menu
        getContentAnchorEl={null}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        keepMounted
        PaperProps={{ className: classes.popover }}
        anchorEl={ref.current}
        open={isOpen}
      >
        {renderMenuItem(<AccountCircle />, "Perfil", {
          to: profilePath,
          component: Link,
        })}
        {rol === Roles.admin && [
          renderMenuItem(<Settings />, "Configuraciones", {
            to: "/administrador/conjuntos/configuraciones",
            component: Link,
            key: "settings",
          }),
          renderMenuItem(<Edit />, "Editar Conjunto", {
            to: "/administrador/editarConjunto",
            component: Link,
            key: "edit-complex",
          }),
        ]}
        <RolesSelector rol={rol} roles={user.roles} />
        {user.roles.test && <LanguageSelector />}
        {renderMenuItem(<ExitToApp />, "Cerrar sesión", {
          onClick: handleLogout,
        })}
      </Menu>
    </>
  )
}

export default Account
